import React from 'react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { PageBlueprint } from '@backstage/frontend-plugin-api';

const homePage = PageBlueprint.make({
  params: {
    path: '/',
    title: 'Home',
    noHeader: true,
    loader: async () => {
      const { HomePage } = await import('./HomePage');
      return React.createElement(HomePage);
    },
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [homePage],
});
